<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <MenuCard :menuItems="visibleMenuItems" />
    </Layout>
</template>
<script>
import Layout from "@/views/layouts/main";
import PageHeader from "@/components/page-header";
import i18n from "@/i18n";
import MenuCard from "@/components/MenuCard";
import { sessionHelper } from "@/utils";

export default {
    page: {
        title: i18n.t("module.orientation"),
    },
    components: { Layout, PageHeader, MenuCard },
    computed: {
        visibleMenuItems() {
            const user = this.$store.state.api.auth.user?.user;
            const level = sessionHelper.getUserPermissions(user?.permissions, user?.isSuperadmin).cert_admin || 0;
            return this.menuItems.filter(item => item.route !== 'Certificate' || level >= 1);
        },
    },
    data() {
        return {
            title: i18n.t("module.orientation"),
            items: [
                {
                    text: i18n.t("module.orientation"),
                    active: true,
                },
            ],
            menuItems: [
                {
                    route: 'OrientationModule',
                    label: i18n.t('module.module'),
                    icon: 'mdi-clipboard-outline',
                    color: 'info',
                    core: true,
                },
                {
                    route: 'OrientationModuleAssignment',
                    label: i18n.t('module.assignment'),
                    icon: 'mdi-clipboard-check',
                    color: 'success',
                    core: true,
                },
                {
                    route: 'Workgroup',
                    label: i18n.t('module.workgroup'),
                    icon: 'mdi-file-tree',
                    color: 'primary',
                    core: true,
                },
                {
                    route: 'Certificate',
                    label: i18n.t('module.certificate'),
                    icon: 'mdi-certificate-outline',
                    color: 'info',
                    core: false,
                },
            ],
        };
    },
}
</script>